import { render, staticRenderFns } from "./Facilitator.vue?vue&type=template&id=00f1200a&scoped=true&"
import script from "./Facilitator.vue?vue&type=script&lang=js&"
export * from "./Facilitator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1200a",
  null
  
)

export default component.exports